module.exports = __webpack_public_path__ + "templates/token.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/token.html
// module id = jzxG
// module chunks = 1